<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th colspan="5">
          <div class="col-4 col-sm-4 col-md-4 px-0">
            <select class="custom-select custom-select-sm col-12 pb-0 mb-0" v-model="selectCategoria"
                    @change="escogerCategoria">
              <option selected value="Seleccionar categoria">Seleccionar categoria</option>
              <option v-for="categoria in listaCategoriasMasAyudas" v-bind:value="categoria.id">
                {{categoria.categoria}}
              </option>
            </select>
          </div>
        </th>
      </tr>
      <tr>
        <th>Contenido</th>
        <th>Posición</th>
      </tr>
      </thead>
      <tbody>
      <tr class="tr-contenido" v-for="contenido in contenidos.data">
        <td class="py-1 my-1 td-titulo">{{contenido.titulo}}</td>
        <td class="py-1 my-1">
          <button type="submit" class="btn btn-secondary btn-sm btn-outline-success py-0"
                  v-if="visibilidadposicionMasAyuda != contenido.id" title="Editar posición"
                  @click="editarPosicionMasAyuda(contenido)">{{ contenido.ordenAyuda }}
          </button>
          <div class="input-group" v-else>
            <div class="input-group-prepend">
              <button class="btn btn-outline-danger btn-sm  py-0 px-1" type="submit" title="Cancelar"
                      @click="cancelarPosicionMasAyuda(contenido)">
                <i class="far fa-times-circle"></i>
              </button>
            </div>
            <input type="number" min="0" class="py-1 input-group-sm" placeholder="0" aria-label=""
                   aria-describedby="basic-addon1"
                   style="height: 21px; width: 40px" data-toggle="tooltip" data-placement="bottom"
                   title="Agregue la posición" :onmouseover="tooltop()" v-model="contenido.ordenAyuda">
            <div class="input-group-prepend">
              <button class="btn btn-outline-primary btn-sm  py-0 px-1" type="submit" title="Guardar"
                      @click="guardarPosicionMasAyuda(contenido)"><i class="far fa-save"></i>
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import servicioApi from '../../../servicioApi';

  export default {
    name: "masAyudas",
    data() {
      return {
        visibilidadposicionMasAyuda: '',
        listaCategoriasMasAyudas: {},
        selectCategoria: 'Seleccionar categoria',
        contenidos: {}
      }
    },
    created() {
      EventBus.$on("listcategorias", data => {
        this.listaCategoriasMasAyudas = data;
      });
    },
    methods: {
      tooltop() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        })
      },
      editarPosicionMasAyuda(data) {
        console.log(data);
        this.visibilidadposicionMasAyuda = data.id;
        this.position = data.ordenAyuda;
        console.log(this.visibilidadposicionMasAyuda)
      },
      guardarPosicionMasAyuda(data) {
        console.log(data);
        let categoriaEtiqueta = {
          categoria_id: data.categoria_id,
          contenido_id: data.id,
          categoriaSeleccionada: this.selectCategoria,
          ordenAyuda: data.ordenAyuda
        };
        console.log(categoriaEtiqueta);
        servicioApi.rol_regular.masAyudas.putMasAyudas(categoriaEtiqueta).then(resp => {
          console.log(resp);
          this.visibilidadposicionMasAyuda = '';
          this.escogerCategoria();
        }).catch(e => {
        });
      },
      cancelarPosicionMasAyuda(data) {
        console.log(data);
        this.visibilidadposicionMasAyuda = '';
        data.ordenAyuda = this.position;
        console.log(this.visibilidadposicionMasAyuda)
      },
      escogerCategoria() {
        servicioApi.rol_regular.masAyudas.getMasAyudas(this.selectCategoria).then(resp => {
          this.contenidos = resp.data;
        }).catch(e => {
        });
      },
      cargarListaCategorias() {
        servicioApi.rol_regular.categorias.getListarCategorias().then(resp => {
          this.listaCategorias = resp.data.data[0];
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-select:focus {
    background-size: 8px 10px;
    border: 1px solid rgba(0, 0, 0, .26);
    border-radius: .125rem;
    -webkit-appearance: none;

    border-color: rgba(0, 0, 0, .26);
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/regular/contenido/componentes/masAyudas.vue